import React from 'react';
import Home from './Home';
import './App.css';
import './LoginPage.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
 
function App() {
  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userEmail');
    // Optional: You can decide what to do on logout, e.g., redirect somewhere
  };
 
  return (
   <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home onLogout={handleLogout} />} />
        <Route path="/:levelParam" element={<Home onLogout={handleLogout} />} />
      </Routes>
    </BrowserRouter>
    
  );
}
 
export default App;
 
 